import React from 'react'
import clsx from 'clsx'

import { Icon } from '@wartek-id/icon'
import { Button } from '@wartek-id/button-v1'

type ExpandableContentProps = {
  title: string
  children: React.ReactNode
}

export const ExpandableContent = (props: ExpandableContentProps) => {
  const [isExpanded, setIsExpanded] = React.useState(false)
  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        className="!px-0"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {props.title}
        <Icon
          as="i"
          color="informational"
          fontSize="default"
          className={clsx(
            isExpanded ? 'transform rotate-180 origin-center' : ''
          )}
        >
          keyboard_arrow_down_icon
        </Icon>
      </Button>

      {/* expanded content section */}
      {isExpanded && <>{props.children}</>}
    </>
  )
}
